<template>
    <div>
        <h2 class="titulo">Selecione o Produto</h2>
        <v-layout wrap class="produtos-btns row-padding">
            <v-flex v-for="(modalidade, index) in modalidades_selecionadas" :key="index">
                <card-produto
                        :icone="modalidade.icone"
                        :identificador-produto="index"
                        :modalidade="modalidade.modalidade"
                        :nome="modalidade.nome"
                        @onSelecionarProduto="selecionarModalidade"
                />
            </v-flex>
        </v-layout>

        <ListDialog v-model="show_dialog"
                    title="SELECIONE UMA OPÇÃO"
                    :items="produtos"
                    @select="selecionarProduto"
                    show-close-button
                    no-search
                    item-text="nome_produto" />

        <v-btn v-if="!fluxoProduto" color="secondary" text @click="voltar()" id="produto_voltar">Voltar</v-btn>
    </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { cloneDeep } from 'lodash'
  import CardProduto from '@/components/CardProduto'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { notification } from '../../../plugins/helpers'

  export default {
    components: { CardProduto },
    props: { value: Object },
    data: () => ({
      produtos: [],
      produtos_do_grupo: [],
      show_dialog: false,
      dialog_filial: false,
      pedido: {
        produto: {}
      },
      modalidades_selecionadas: [],
      permitir_venda: false
    }),
    computed: {
      ...mapGetters([
        'modalidadesEmpresa'
      ]),
      ...mapState(['jornada_venda']),
      fluxoProduto () {
        return this.$route.name === 'iniciar-venda'
      },
      modalidadeSelecionada () {
        if ('id_produto' in this.pedido.produto) {
          return this.modalidades_selecionadas
            .filter(modalidade =>
              modalidade.produtos
                .some(produto =>
                  produto.id_produto === this.pedido.produto.id_produto
                )
            )[0]
        }
        return undefined
      }
    },
    watch: {
      value (val) {
        this.pedido = Object.assign({}, this.pedido, val)
        this.filtraModalidades()
      }
    },
    mounted () {
      this.pedido = Object.assign({}, this.pedido, this.value)
      this.$session.set('nm_tabela_venda', null)
      if (this.pedido.id_reserva) {
        this.$http.get(`/compra/produtos/${(!this.pedido.grupo) ? this.pedido.id_grupo : (this.pedido.grupo.id_grupo !== undefined ? this.pedido.grupo.id_grupo : this.pedido.id_grupo)}?id_reserva=${this.pedido.id_reserva}`)
          .then((res) => {
            this.produtos_do_grupo = res.data
            this.filtraModalidades()
          })
          .catch((error) => {
            if (error.response && error.response.status === 404) {
              notification(AlertTypes.ERROR, error.response.data.error)
            } else {
              notification(AlertTypes.ERROR, 'Caro parceiro, ocorreu um erro ao carregar algumas informações! Tente novamente mais tarde e caso o erro persista, entre em contato com a Área de Suporte.')
            }
          })
      } else {
        this.filtraModalidades()
      }
    },
    methods: {
      selecionarModalidade (index) {
        this.produtos = this.modalidades_selecionadas[index].produtos
        if (this.produtos.length > 1) {
          this.show_dialog = true
        } else {
          this.selecionarProduto(this.produtos[0])
        }
      },
      async filtraModalidades () {
        const modalidadesFiltradas = cloneDeep(await this.modalidadesEmpresa)
        const produtos_do_grupo = cloneDeep(this.produtos_do_grupo)

        if (this.pedido.id_reserva) {
          this.modalidades_selecionadas = Object.values(modalidadesFiltradas).filter(modalidade => {
            return modalidade.produtos.some(produto =>
              produtos_do_grupo.some(p => String(p.id_produto) === String(produto.id_produto))
            )
          })

          this.modalidades_selecionadas.forEach(modalidade => {
            modalidade.produtos = modalidade.produtos.filter(produto =>
              produtos_do_grupo.some(p => String(p.id_produto) === String(produto.id_produto))
            )
          })
        } else {
          this.modalidades_selecionadas = modalidadesFiltradas
        }
      },
      selecionarProduto (produto) {
        this.show_dialog = false
        this.pedido.produto = produto

        sendAnalyticsEvent(this.$gtag, 'produto_selecionarProduto', {
          tipo_produto: this.modalidadeSelecionada.nome,
          opcao_produto: this.pedido.produto.nome_produto,
          source_menu: this.jornada_venda
        })

        this.$emit('input', this.pedido)
        this.$emit('nextPage')
      },
      voltar () {
        delete this.pedido.produto
        delete this.pedido.plano
        this.$emit('prevPage')
      }
    }
  }
</script>

<style scoped lang="scss">
    .flex {
        padding: 15px;
        flex-basis: 33%;
    }
</style>
